import * as angular from 'angular';

import './scripts/lib/angular-drag-and-drop-lists/angular-drag-and-drop-lists';
import './scripts/lib/angular-timepicker/dist/angular-timepicker.min';

import './views/display/_views-display';
import './views/edit/_views-edit';
import './views/value/_views-value';
import './views/validators/display/_views-validators-display';
import './views/validators/edit/_views-validators-edit';

import './images/sprite/svg-sprite.out.svg';
import './images/bw/favicon.bw.png';
import './images/amt24/favicon.amt24.png';
import './images/ozghub/favicon.ozghub.png';

import './scripts/app';
import './scripts/mappings';
import './scripts/services/formHandler';
import './scripts/services/fieldGroupService';
import './scripts/services/elementHelper';
import './scripts/services/validationHelper';
import './scripts/services/formHelper';
import './scripts/services/tableHelper';
import './scripts/services/navigationGuard';
import './scripts/services/resizeGuard';
import './scripts/services/engineVersionHandler';
import './scripts/controllers/main';
import './scripts/controllers/fdEditOverlay';
import './scripts/controllers/fdExternalDataSource';
import './scripts/controllers/fdHelpDialog';
import './scripts/controllers/fdCustomButtons';
import './scripts/controllers/fdPreview';
import './scripts/directives/fdAnbindung';
import './scripts/directives/fdEditOverlay';
import './scripts/directives/fdExternalDataSource';
import './scripts/directives/fdCustomButtons';
import './scripts/directives/fdCustomButtonForm';
import './scripts/directives/fdPreview';
import './scripts/directives/fdRuleset';
import './scripts/directives/fdVorbelegung';
import './scripts/directives/fdHelpDialog';

import './components/_components';
import './styles/main.scss';
import { ConditionService } from './shared/condition.service';
import { RecursionHelper } from './shared/recursionHelper.service';
import { referenceFieldPickerDirective } from './shared/referenceFieldPicker/referenceFieldPicker.directive';
// import './scripts/directives/sbformblock';

angular.element(document).ready(function () {
  $.get('./config.json', function (data) {
    angular
      .module('formApp')
      .constant('CONFIG', data)
      .factory('RecursionHelper', RecursionHelper)
      .directive('fdReferenceFieldPicker', referenceFieldPickerDirective)
      .service('ConditionService', ConditionService);

    angular.bootstrap(document, ['formApp']);
  });
});
